import React, { useRef } from 'react';
import { Button, Text } from '@fragments';
import { IconCheck, IconPlus } from '@tabler/icons-react';
import SocialAvatar from '../../../../components/SocialAvatar';
import { profileKey } from '../../../../hooks/useAccounts';
import './styles.scss';

const STEPS = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };

// Every Instagram profile of the creator, its own first: tabs beside the selected one (a
// strip on phones, so both arrow axes move). The check marks the profile in use; another
// one is connected through the @ onboarding on the home, while the limit allows.
export default function ProfileList({ studio: s, manager }) {
  const { t } = s;
  const { list, active } = s.accounts;
  const tabs = useRef(null);
  const activeKey = active ? profileKey(active) : null;
  const move = (event, index) => {
    const step = STEPS[event.key];
    const target = step ? (index + step + list.length) % list.length : event.key === 'Home' ? 0 : event.key === 'End' ? list.length - 1 : null;
    if (target === null) return;
    event.preventDefault();
    manager.choose(list[target]);
    tabs.current?.querySelectorAll('[role="tab"]')[target]?.focus();
  };
  return <div className="studio-profile-list">
    <div className="studio-profile-list__head">
      <Text.subheading contrast={6}>{t('profilesConnected')}</Text.subheading>
      {manager.max != null && <Text.caption contrast={5}>{t('profilesCount', { current: list.length, max: manager.max })}</Text.caption>}
    </div>
    <div ref={tabs} role="tablist" aria-label={t('profilesConnected')} className="studio-profile-list__tabs">
      {list.map((profile, index) => {
        const key = profileKey(profile);
        const selected = key === manager.selectedKey;
        const inUse = key === activeKey;
        return <Button key={key} id={manager.tabId(profile)} role="tab" aria-selected={selected} aria-controls={manager.paneId} tabIndex={selected ? 0 : -1}
          variant="rounded" discreet color="overlay" fullWidth preventLoading className={`studio-profile-list__tab${selected ? ' is-selected' : ''}`}
          startIcon={<SocialAvatar picture={profile.picture} label={profile.handle} platform={profile.platform} />}
          endIcon={inUse ? <IconCheck aria-hidden="true" /> : null}
          onClick={() => manager.choose(profile)} onKeyDown={event => move(event, index)}>
          <Text.span contrast={selected ? 9 : 7} maxLines={1}>{`@${profile.handle}`}</Text.span>
          {inUse && <span className="studio-visually-hidden">{`, ${t('profileInUse')}`}</span>}
        </Button>;
      })}
    </div>
    {manager.multiple && (manager.canAdd
      ? <Button variant="rounded" discreet color="overlay" fullWidth className="studio-profile-list__connect" startIcon={<IconPlus />} onClick={manager.connect}>
        <Text.span contrast={7} maxLines={1}>{t('profileConnect')}</Text.span>
      </Button>
      : <Text.caption className="studio-profile-list__limit" contrast={5}>{t('profileLimitReached', { max: manager.max })}</Text.caption>)}
  </div>;
}
